module.exports = {
    changeHeaderColor: function () {
        $(window).on('scroll', function () {
            if ($(window).scrollTop() > 48) {
                $('.header-main-wrapper').addClass('active');
            } else {
                $('.header-main-wrapper').removeClass('active');
            }
        });
    },

    openSearch: function () {
        $('.search-icon').on('click', function () {
            $('.search-block-content').removeClass('d-none');
            $('.header-main-wrapper').addClass('d-none');
            $('html').css({ 'overflow-y': 'hidden' });
            $('.search-block-content').find('.search-field').trigger('focus');
        });

        $('.close-search-button').on('click', function () {
            $('.search-block-content').addClass('d-none');
            $('.header-main-wrapper').removeClass('d-none');
            $('html').css({ 'overflow-y': 'unset' });
        });
    },


    /**
    * Initializes and configures the header banner slider using the Slick library.
    * If the header banner slider element is not found, the function exits early.
    * The slider is set to autoplay with a speed of 3500ms and hides arrows on screens smaller than 768px.
    */
    headerBanner: function () {
        const $headerBannerSlider = $('.header-banner-slider');

        if (!$headerBannerSlider || $headerBannerSlider.length === 0) {
            return;
        }

        $headerBannerSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3500,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: false
                    }
                }
            ]
        });
    }
};
